import React, { useEffect, useRef, useState } from "react";
import { Loader } from "../global/loader";
import add from "../../images/add.png";
import { useSelector } from "react-redux";
import api from "../../api";
import { useAlert } from "react-alert";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import moment from "moment";
import ReactQuill from "react-quill";
import { Pagination, Stack } from "@mui/material";
import { Modal } from "react-bootstrap";
var Editor = {
  toolbar: false,
};

export const TicketdetailAdmin = ({ checkMessageNotificationAdmin }) => {
  const alert = useAlert();
  const params = useParams();
  const adminStore = useSelector((state) => state.adminReducer);
  const navigate = useNavigate();

  const [paid, setPaid] = useState(false);
  const [loader, setLoader] = useState(false);
  const [data, setData] = useState({});
  const [msgInput, setMsgInput] = useState("");

  const [editModal, setEditModal] = useState(false);
  const [messageId, setMessageId] = useState("");
  const [newMessage, setNewMessage] = useState("");

  const [dataTicket, setDataTicket] = useState([]);

  const chatRef = useRef(null);

  const getTickets = async () => {
    try {
      setLoader(true);
      // let token = localStorage.getItem("token");
      // axios.defaults.headers.common["Authorization"] = token;
      const response = await api.adminGetTicket(params?.id);
      // console.log(response);
      if (response?.success) {
        setData(response?.ticket);
        checkMessageNotificationAdmin();
        if (response?.subscription) {
          let currentDate = new Date();
          let endDate = new Date(response?.subscription?.nextPayment);
          if (currentDate < endDate) {
            setPaid(true);
          }
        }
      }
      setLoader(false);
    } catch (error) {
      console.log(error);
      setLoader(false);
    }
  };

  useEffect(() => {
    if (params?.id) {
      getTickets();
    }
  }, []);

  const formatDate = (date) => {
    let dateTemp = moment(date).format("MMMM Do YYYY, h:mm:ss a");
    return dateTemp;
  };
  const formatDateMessage = (date) => {
    let dateTemp = moment(date).format("MMMM Do YY, h:mm a");
    return dateTemp;
  };

  const addMessage = async () => {
    try {
      setLoader(true);
      let payload = {
        id: data.issueId,
        sender: "admin",
        message: msgInput,
      };
      // console.log(payload);
      const response = await api.adminTicketChat(payload);
      // console.log(response);
      if (response?.success) {
        setMsgInput("");
        setData(response?.ticket);
      }
      setLoader(false);
    } catch (error) {
      console.log(error.message);

      alert.show(error.message || "Something went wrong.");
      setLoader(false);
    }
  };

  const editTicketStatus = async (status) => {
    try {
      if (!status) {
        return;
      }
      setLoader(true);
      let payload = {
        id: data.issueId,
        status: status,
      };
      const response = await api.adminEditTicket(payload);
      // console.log(response);
      if (response?.success) {
        setData({
          ...data,
          status: response?.ticket?.status,
        });
      }
      setLoader(false);
    } catch (error) {
      console.log(error.message);

      alert.show(error.message || "Something went wrong.");
      setLoader(false);
    }
  };

  useEffect(() => {
    const intervalId = setInterval(() => {
      getTickets();
    }, 20000); // 30,000 ms = 30 seconds

    // Cleanup on component unmount
    return () => {
      clearInterval(intervalId);
    };
  }, []);

  const editMessage = async () => {
    try {
      setLoader(true);
      let payload = {
        issueId: data.issueId,
        messageId: messageId,
        newMessage: newMessage,
      };
      // console.log(payload);
      const response = await api.adminEditTicketChat(payload);
      // console.log(response);
      if (response?.success) {
        setEditModal(false);
        setMessageId("");
        setNewMessage("");
        getTickets();
        alert.show(response?.message);
      } else {
        alert.show(response?.error || "Something went wrong.");
      }
      setLoader(false);
    } catch (err) {
      alert.show(err.message || "Something went wrong.");
      setLoader(false);
    }
  };

  const handleEditModal = (id, message) => {
    setMessageId(id);
    setNewMessage(message);
    setEditModal(true);
  };

  const scrollToBottom = () => {
    if (chatRef.current) {
      chatRef.current.scrollTop = chatRef.current.scrollHeight;
    }
  };
  useEffect(() => {
    scrollToBottom();
  }, [data?.messages]);

  // other ticket
  const otherTicketsOfUser = async () => {
    if (data?.userId?.email) {
      let payload = {
        email: data?.userId?.email,
      };
      const res = await api.adminSearchTicket(payload);
      // console.log(res);
      if (res?.success) {
        setDataTicket(res?.tickets);
      } else {
        console.log("other ticket not found");
      }
    }
  };

  useEffect(() => {
    otherTicketsOfUser();
  }, [data?.userId?.email]);

  return (
    <div className="createTicketPage payHistoryPage">
      <div className="contact-widget-area ">
        <div className="contact-widget-area-inner">
          <div className="backBtn" onClick={() => navigate(-1)}>
            <i className="fa-solid fa-circle-left"></i>
          </div>
          <h2 className="section-title text-center mb-45">Ticket Detail</h2>
          <div className="row">
            <div className="col-md-6">
              <div className="issueDetail">
                <div className="mb-3">
                  <div className="markAs">
                    <div className="value">Mark As</div>
                    <select
                      onChange={(e) => editTicketStatus(e.target.value)}
                      defaultValue={data?.status}
                    >
                      <option
                        value="pending"
                        selected={data?.status == "pending" ? true : false}
                      >
                        Pending
                      </option>
                      <option
                        value="processing"
                        selected={data?.status == "processing" ? true : false}
                      >
                        Processing
                      </option>
                      <option
                        value="closed"
                        selected={data?.status == "closed" ? true : false}
                      >
                        Closed
                      </option>
                    </select>
                  </div>
                  <div className="value">Email</div>
                  <div className="title">{data?.userId?.email}</div>
                </div>
                <div className="mb-3">
                  <div className="value">Username</div>
                  <div className="title">
                    {data?.userId?.name}
                    {paid ? (
                      <span className="badge bg-success ms-2">PAID</span>
                    ) : (
                      <span className="badge bg-danger ms-2">NON PAID</span>
                    )}
                  </div>
                </div>
                <div className="mb-3">
                  <div className="value">Issue ID</div>
                  <div className="title">{data?.issueId}</div>
                </div>
                <div className="mb-3">
                  <div className="value">Issue type</div>
                  <div className="title">{data?.issueType}</div>
                </div>
                <div className="mb-3">
                  <div className="value">Issue Status</div>
                  <div className="title text-capitalized">{data?.status}</div>
                </div>

                {data?.processedBy?.name && (
                  <div className="mb-3">
                    <div className="value">Processed By</div>
                    <div className="title text-capitalized">
                      {data?.processedBy?.name}
                    </div>
                  </div>
                )}
                {data?.closedBy?.name && (
                  <div className="mb-3">
                    <div className="value">Closed by</div>
                    <div className="title text-capitalized">
                      {data?.closedBy?.name}
                    </div>
                  </div>
                )}
                <div className="mb-3">
                  <div className="value">Issue Description</div>
                  <div className="title">{data?.description}</div>
                </div>
                <div className="mb-3">
                  <div className="value">Issue Created At</div>
                  <div className="title">{formatDate(data?.createdAt)}</div>
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="chatMain support">
                {editModal && (
                  <EditModalComp
                    newMessage={newMessage}
                    editMessage={editMessage}
                    setNewMessage={setNewMessage}
                    setEditModal={setEditModal}
                  />
                )}
                <div className="chatTitle">Chat</div>
                {data?.status == "processing" && (
                  <div className="alert alert-warning py-2" role="alert">
                    Note: This ticket will be closed if you do not respond
                    within 48 hours.
                  </div>
                )}
                {data?.status == "processing" || data?.status == "closed" ? (
                  <>
                    <div className="chatMainCol" ref={chatRef}>
                      {data?.messages?.map((val, key) => (
                        <div
                          className={
                            val?.sender == "user" ? "sender" : "receiver"
                          }
                          key={key}
                        >
                          <div
                            dangerouslySetInnerHTML={{
                              __html: val?.message,
                            }}
                          />
                          <div className="time">
                            {formatDateMessage(val?.timestamp)}
                          </div>
                          {val?.sender == "user" && (
                            <>
                              <div className="name">{val?.senderId?.name}</div>
                            </>
                          )}
                          {val?.sender == "admin" && (
                            <>
                              {val?.senderId?._id ===
                                adminStore?.admin?.admin?._id &&
                                new Date() - new Date(val?.timestamp) <=
                                  5 * 60 * 1000 && (
                                  <div className="dropD dropdown">
                                    <i
                                      className="fa-solid fa-ellipsis-vertical"
                                      id="dropdownMenuButton1"
                                      data-bs-toggle="dropdown"
                                      aria-expanded="false"
                                    ></i>
                                    <ul
                                      class="dropdown-menu"
                                      aria-labelledby="dropdownMenuButton1"
                                    >
                                      <li>
                                        <a
                                          className="dropdown-item"
                                          onClick={() =>
                                            handleEditModal(
                                              val?._id,
                                              val?.message
                                            )
                                          }
                                        >
                                          Edit
                                        </a>
                                      </li>
                                    </ul>
                                  </div>
                                )}
                            </>
                          )}
                        </div>
                      ))}
                      {/* <div className="sender">test</div> */}
                    </div>
                    <div className="senMsg">
                      <ReactQuill
                        placeholder={
                          data?.status == "closed"
                            ? "Chat is closed"
                            : "Type here..."
                        }
                        modules={Editor}
                        theme="snow"
                        value={msgInput}
                        onChange={setMsgInput}
                      />
                      {/* <textarea
                        rows={1}
                        placeholder={
                          data?.status == "closed"
                            ? "Chat is closed"
                            : "Type here..."
                        }
                        value={msgInput}
                        onChange={(e) => setMsgInput(e.target.value)}
                      ></textarea> */}
                      <button
                        disabled={
                          msgInput && data?.status == "processing"
                            ? false
                            : true
                        }
                        onClick={addMessage}
                        className="button"
                      >
                        <i className="fa-solid fa-paper-plane"></i>
                      </button>
                    </div>
                  </>
                ) : (
                  <h6 className="text-center">
                    Chat is available when the status of ticket is open.
                  </h6>
                )}
              </div>
            </div>

            <div className="col-12">
              <h3 className="mb-0 mt-4">User Other Tickets</h3>
              <Table data={dataTicket} />
            </div>
          </div>
        </div>
      </div>
      {loader && <Loader />}
    </div>
  );
};

const EditModalComp = ({
  editMessage,
  newMessage,
  setNewMessage,
  setEditModal,
}) => {
  return (
    <>
      <div className="editModal">
        <div className="closeModal" onClick={() => setEditModal(false)}>
          <i className="fa-solid fa-xmark"></i>
        </div>
        <div className="senMsg">
          <ReactQuill
            placeholder="Add Email description"
            modules={Editor}
            theme="snow"
            value={newMessage}
            onChange={setNewMessage}
          />
          {/* <textarea
            rows={1}
            placeholder="Type here..."
            value={newMessage}
            onChange={(e) => setNewMessage(e.target.value)}
          ></textarea> */}
          <button
            className="button"
            disabled={newMessage ? false : true}
            onClick={editMessage}
          >
            <i className="fa-solid fa-paper-plane"></i>
          </button>
        </div>
      </div>
    </>
  );
};

const Table = ({ data }) => {
  // const authedUser = useSelector(s => s.authedUser.authedUser);
  const [activeImg, setActiveImg] = useState("");
  const [showMore, setShowMore] = useState(false);
  const handleCloseMore = () => setShowMore(false);
  const handleShowMore = () => setShowMore(true);

  const navigate = useNavigate();

  const formatDate = (date) => {
    let dateTemp = moment(date).format("MMMM Do YYYY, h:mm:ss a");
    return dateTemp;
  };

  const handleActiveImg = (link) => {
    setActiveImg(link);
    handleShowMore();
  };

  return (
    <>
      <div className="card sortby-box br-10 border-transparent">
        <div className="card-header br-10  bg-white border-transparent pb-3 pt-0 px-0 ">
          <div className="table-responsive">
            <table className="table table-hover ">
              <thead>
                <tr>
                  <th scope="col" className="">
                    Issue ID
                  </th>
                  <th scope="col" className="">
                    Image
                  </th>
                  <th scope="col" className="">
                    User Email
                  </th>
                  <th scope="col" className="">
                    Status
                  </th>
                  <th scope="col" className="">
                    Issue Type
                  </th>
                  <th scope="col" className="">
                    Created At
                  </th>
                  <th scope="col" className="">
                    <div className="w-max">Processed By</div>
                  </th>
                  <th scope="col" className="">
                    Closed By
                  </th>
                  <th scope="col" className="">
                    Expected to close
                  </th>
                  <th scope="col" className="">
                    View
                  </th>
                </tr>
              </thead>
              <tbody>
                {data.map((item, key) => (
                  <tr key={key}>
                    <td>
                      <div className="table-text-dark w-max-c db">
                        {item?.issueId}
                      </div>
                    </td>
                    <td>
                      {item?.imageTitle ? (
                        <div
                          className="pImage"
                          style={{ maxWidth: 120, padding: 5 }}
                          onClick={() =>
                            handleActiveImg(
                              `${process.env.REACT_APP_S3URL}/img_${item?.imageTitle}.${item.imageFormat}`
                            )
                          }
                        >
                          <img
                            src={`${process.env.REACT_APP_S3URL}/img_${item?.imageTitle}.${item.imageFormat}`}
                            alt=""
                          />
                        </div>
                      ) : (
                        <div className="text-center">-</div>
                      )}
                    </td>
                    <td>
                      <div className="table-text-dark w-max-c db">
                        {item?.userId?.email}
                      </div>
                    </td>
                    <td scope="row">
                      <div
                        className={
                          item?.status == "pending"
                            ? "red table-text-dark w-max-c db"
                            : item?.status == "processing"
                            ? " yellow table-text-dark w-max-c db"
                            : "green table-text-dark w-max-c db"
                        }
                      >
                        {item?.status}
                      </div>
                    </td>
                    <td scope="row">
                      <div className="table-text-dark w-max-c db">
                        {item?.issueType}
                      </div>
                    </td>
                    <td>
                      <span className="table-text-dark w-max-c db">
                        {formatDate(item?.createdAt)}
                      </span>
                    </td>
                    <td scope="row">
                      <div className="table-text-dark w-max-c db">
                        {item?.processedBy?.name || "-"}
                      </div>
                    </td>
                    <td scope="row">
                      <div className="table-text-dark w-max-c db">
                        {item?.closedBy?.name || "-"}
                      </div>
                    </td>
                    <td scope="row">
                      <div className="table-text-dark d-flex jc-center">
                        {/* check ticket message is unread */}
                        {item?.latestUserMessageSeen === false && (
                          <div className="masgNotSeen">
                            <i className="fa-solid fa-message"></i>
                            <span></span>
                          </div>
                        )}
                        {item?.status == "processing" &&
                        item?.processingStartedAt ? (
                          <TicketTimer
                            processingStartedAt={item?.processingStartedAt}
                          />
                        ) : (
                          "-"
                        )}
                      </div>
                    </td>
                    <td>
                      <i
                        className="fa-solid fa-eye cursor-pointer"
                        onClick={() =>
                          navigate(`/admin/support/ticket/${item?.issueId}`)
                        }
                      ></i>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <Modal size="lg" show={showMore} onHide={handleCloseMore} centered>
        <Modal.Body>
          <div className="otpModalMain broadcastModal">
            <div className="closeIcon" onClick={handleCloseMore}>
              <i className="fa-solid fa-xmark" />
            </div>

            <div className="showMoreModalM py-4">
              <div className="showMoreModal">
                <img className="w-100" src={activeImg} alt="" />
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

const TicketTimer = ({ processingStartedAt }) => {
  const [timeLeft, setTimeLeft] = useState("");

  useEffect(() => {
    const interval = setInterval(() => {
      const startTime = new Date(processingStartedAt).getTime();
      const endTime = startTime + 48 * 60 * 60 * 1000; // 48 hours in ms
      const now = new Date().getTime();
      const remaining = endTime - now;

      if (remaining <= 0) {
        setTimeLeft("Exceeded");
        clearInterval(interval);
        return;
      }

      const hours = Math.floor(remaining / (1000 * 60 * 60));
      const minutes = Math.floor((remaining % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((remaining % (1000 * 60)) / 1000);

      setTimeLeft(`${hours}h ${minutes}m ${seconds}s`);
    }, 1000);

    return () => clearInterval(interval);
  }, [processingStartedAt]);

  return (
    <div className="text-sm font-medium text-blue-600 w-max-c">
      {timeLeft ? `${timeLeft}` : "-"}
    </div>
  );
};
